import { z } from "zod";

const requestId = z
  .string()
  .min(1)
  .max(191)
  .regex(/^[A-Za-z0-9][A-Za-z0-9:_.-]*$/)
  .optional();

// Retained messages may contain retry diagnostics and producer fields unknown to this release.
export const processingQueuePayloadSchema = z
  .looseObject({
    fileId: z.number().int().positive().safe(),
    mrfileId: z.number().int().positive().safe().nullable().optional(),
    retries: z.number().int().nonnegative().safe().default(0),
    language: z.string().max(100).nullable().optional(),
    // The language spoken in the recording (ISO 639-3), as chosen or as
    // detected after Stop for "Detect automatically". Set by the worker's
    // transcription stage for note generation; older messages lack it.
    spokenLanguage: z.string().max(100).nullable().optional(),
    // Set by the worker's transcription stage: the transcript was made from
    // the recorded audio (an upload or a recording after Stop), so it is not
    // checked against the audio again as a live transcript, even when its
    // language was not detected.
    transcribed: z.boolean().optional(),
    requestId,
  })
  .catchall(z.json());
export const anonymizationQueuePayloadSchema = z
  .looseObject({
    audio_file_name: z.string().min(1).max(1024),
    data: processingQueuePayloadSchema,
    requestId,
  })
  .catchall(z.json());
export type ProcessingQueuePayload = z.infer<
  typeof processingQueuePayloadSchema
>;
export type AnonymizationQueuePayload = z.infer<
  typeof anonymizationQueuePayloadSchema
>;
